<template>
  <div class="page_content">

    <div class="row page-heading">
	     <div class="col-8 input module_heading">
            <span class="module_icon fas fa-cloud-upload-alt"></span>
            <span class="module_type_name">Task Monitor</span>
        </div>
        <div class="col-4 submit btn-container text-right">
            <button type="button" class="btn btn-primary" @click.prevent="viewUploadHistory" aria-label="view your uploads history">view your tasks history</button>
        </div>
    </div>

    <div class="task-monitor create-section">
        <div class="content-section">
          	<div class="content-row row">
            	<span class="title col-4">Task Name:</span>
            	<span class="col-8">{{formattedTaskMonitor.title}}</span>
            </div>
            <div class="content-row row">
            	<span class="title col-4">Progress Bar:</span>
            	<span class="col-8">
                    <b-progress :value="formattedTaskMonitor.percentage" show-progress animated></b-progress>
            	</span>
            </div>
            <div class="content-row row">
                <span class="title col-4">Fraction:</span>
                <span class="col-8">{{formattedTaskMonitor.currentTaskSize}} / {{formattedTaskMonitor.totalTaskSize}}</span>
            </div>
            <div class="content-row row">
            	<span class="title col-4">Start Time:</span>
            	<span class="col-8">{{formattedTaskMonitor.formattedStartTime}}</span>
            </div>
            <div class="content-row row">
            	<span class="title col-4">Duration:</span>
            	<span class="col-8">{{formattedTaskMonitor.duration}}</span>
            </div>
            <div class="content-row row" v-if="formattedTaskMonitor.insight">
            	<span class="title col-4" style="padding-left: 50px;">Insight:</span>
            	<b-form-textarea readonly no-auto-shrink rows="5" max-rows="10" style="width: 670px; margin-left: 50px;" v-model="formattedTaskMonitor.insight"></b-form-textarea>
            </div>
            <div class="content-row row" v-if="formattedTaskMonitor.outcome">
            	<span class="title col-4">Outcome:</span>
            	<span class="col-8" v-html="formattedTaskMonitor.outcome"></span>
            </div>
            <div class="content-row row" v-if="formattedTaskMonitor.nextSteps">
            	<span class="title col-4">Next Steps:</span>
            	<span class="col-8" v-html="formattedTaskMonitor.nextSteps"></span>
            </div>
        </div>
    </div>
    
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'

  export default {
    name: 'task-monitor',
    props: ['taskId'],
    data: () => {
      return {
        formattedTaskMonitor: {},
        isInProgress: true,
        interval: null
      }
    },

    mounted () {
      this.loadDataForTaskMonitor()

      this.interval = setInterval(() => {
        this.loadDataForTaskMonitor()
      }, 1000)
    },

    methods: {
      ...mapActions([
        'loadTaskMonitor'
      ]),

      loadDataForTaskMonitor () {
        if (!this.taskId || !this.taskId.length || this.taskId.length <= 0) {
          return
        }
        this.loadTaskMonitor(this.taskId).then(response => {
          this.formattedTaskMonitor = response
          let startTime = response.startTime
          let endTime = response.endTime
          this.formattedTaskMonitor.formattedStartTime = this.changeMillisToDate(startTime)
          this.formattedTaskMonitor.duration = this.duration(startTime, endTime)
          // this.formattedTaskMonitor.duration = (endTime > startTime) ? (Math.round((endTime - startTime) / 1000 / 60 * 100) / 100) : 0 // convert milliseconds to minutes, round to two decimal places
          this.isInProgress = (response.notificationShownToUser === false)
          // task is done, stop sending update requests to backend
          if (!this.isInProgress) {
            clearInterval(this.interval)
          }
        })
      },

      changeMillisToDate (ms) {
        return DateTime.fromMillis(ms).toFormat('LLL dd, yyyy t')
      },

      duration (startTime, endTime) {
        let ms = (endTime - startTime)
        let min = (ms / 1000 / 60) << 0
        let sec = ((ms / 1000) << 0) % 60
        let thou = ms % 1000
        if (('' + sec).length < 2) sec = '0' + sec
        if (('' + thou).length < 3) thou = '0' + thou
        if (('' + thou).length < 3) thou = '0' + thou
        return min + ':' + sec + '.' + thou
      },

      viewUploadHistory () {
        return this.$router.push({name: 'uploadHistory'})
      }
    },

    beforeDestroy: function () {
      clearInterval(this.interval)
    },

    computed: {
      ...mapState({
        'taskMonitor': state => state.taskMonitor.taskMonitorObject
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/taskMonitor/components/TaskMonitor.vue